import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WebService } from 'src/app/web.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  contactForm: FormGroup
  constructor(private fb: FormBuilder, private srv: WebService) {
    this.contactForm = fb.group({
      name: ['', Validators.required],
      contact: ['', Validators.required],
      email: ['', Validators.required],
      subject: ['', Validators.required],
      message: ['', Validators.required],
    })
  }

  ngOnInit(): void {
  }

  submit() {
    this.srv.submitcontactsData(this.contactForm.value).subscribe((res: any) => {
      if (res.status == 200) {
        location.reload()
      }

    });
  }

}
